(function (angular) {
    'use strict';
    angular
        .module('app.directory')
        .config([
            '$stateProvider', 
            '$urlRouterProvider', 
            directoryRoutes
        ]);

    function directoryRoutes($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('app.directory', {
                url: '/find-a-dentist',
                templateUrl: '/app/site/directory/directory.template.html',
                controller: 'app.directory.controller',
                controllerAs: 'vm'
            })
            .state('app.directoryplus', {
                url: '/find-a-dentistplus',
                templateUrl: '/app/site/directory/directory.template.html',
                controller: 'app.directory.controller',
                controllerAs: 'vm'
            });
    }
    
})(angular);